import React, {useEffect} from 'react'
import './Members/View/StyleGuide/members/index.scss'
import {NavigatorForMemberPage} from './Members/Navigator/NavigatorForMemberPage'
import MemberRepo from './Members/Repo/MemberRepo'
import MemberAgreementRepo from './Members/Repo/MemberAgreementRepo'
import {SearchPostCode} from './Common/SearchPostCode'
import {ErrorBoundary, FallbackProps} from 'react-error-boundary'
import {Switch} from 'react-router-dom'
import {RouteWithTitle} from './Common/Components/RouteWithTitle'
import MembersInvitationCompletePage from './Members/View/Pages/Signup/MembersInvitationCompletePage'
import {MembersSignupInputConfirmPage} from './Members/View/Pages/Signup/MembersSignupInputConfirmPage'
import {MembersRegisteredPage} from './Members/View/Pages/Signup/MembersRegisteredPage'
import MembersSignupRedirectPage from './Members/View/Pages/Signup/MembersSignupRedirectPage'
import {MembersAccountTopPage} from './Members/View/Pages/Account/MembersAccountTopPage'
import {MembersAccountInformationPage} from './Members/View/Pages/Account/MembersAccountInformationPage'
import {MembersEditAddressInputPage} from './Members/View/Pages/EditAddress/MembersEditAddressInputPage'
import {MembersEditAddressConfirmPage} from './Members/View/Pages/EditAddress/MembersEditAddressConfirmPage'
import Members404Page from './Members/View/Pages/Error/Members404Page'
import {Members500Page} from './Members/View/Pages/Error/Members500Page'
import MembersInvalidOperationPage from './Members/View/Pages/Error/MembersInvalidOperationPage'
import {MembersDuplicatedRegisterPage} from './Members/View/Pages/Error/MembersDuplicatedRegisterPage'
import {MembersEditAddressCompletePage} from './Members/View/Pages/EditAddress/MembersEditAddressCompletePage'
import {MembersJoinInputPage} from './Members/View/Pages/Join/MembersJoinInputPage'
import {MembersEditMailInputPage} from './Members/View/Pages/EditMail/MembersEditMailInputPage'
import {MembersJoinInputConfirmPage} from './Members/View/Pages/Join/MembersJoinInputConfirmPage'
import {MembersEditMailSendCompletePage} from './Members/View/Pages/EditMail/MembersEditMailSendCompletePage'
import {MembersEditMailUpdatedPage} from './Members/View/Pages/EditMail/MembersEditMailUpdatedPage'
import {MembersEditMailRedirectPage} from './Members/View/Pages/EditMail/MembersEditMailRedirectPage'
import {MembersJoinCompletePage} from './Members/View/Pages/Join/MembersJoinCompletePage'
import MembersInvalidOneTimeUrlPage from './Members/View/Pages/Error/MembersInvalidOneTimeUrlPage'
import {MembersSignupInputPage} from './Members/View/Pages/Signup/MembersSignupInputPage'
import {MembersEditPasswordPage} from './Members/View/Pages/EditPassword/MembersEditPasswordPage'
import {MembersEditMailMagazineInfoPage} from './Members/View/Pages/EditMailMagazine/MembersEditMailMagazineInfoPage'
import {MembersEditPasswordCompletePage} from './Members/View/Pages/EditPassword/MembersEditPasswordCompletePage'
import {MembersEditMailMagazineInputPage} from './Members/View/Pages/EditMailMagazine/MembersEditMailMagazineInputPage'
import {MembersEditMailMagazineConfirmPage} from './Members/View/Pages/EditMailMagazine/MembersEditMailMagazineConfirmPage'
import {MembersInvitationPage} from './Members/View/Pages/Signup/MembersInvitationPage'
import {MembersEditMailMagazineCompletePage} from './Members/View/Pages/EditMailMagazine/MembersEditMailMagazineCompletePage'
import {MembersLeaveBucketInputPage} from './Members/View/Pages/Leave/MembersLeaveBucketInputPage'
import {MembersLeaveBucketConfirmPage} from './Members/View/Pages/Leave/MembersLeaveBucketConfirmPage'
import {MembersLeaveBucketCompletePage} from './Members/View/Pages/Leave/MembersLeaveBucketCompletePage'
import {MembersEditContractInfoPage} from './Members/View/Pages/EditContractInfo/MembersEditContractInfoPage'
import {MembersAuth} from './Members/Auth/MembersAuth'
import {MembersEditContractInputPage} from './Members/View/Pages/EditContractInfo/MembersEditContractInputPage'
import {MembersEditContractConfirmPage} from './Members/View/Pages/EditContractInfo/MembersEditContractConfirmPage'
import {MembersEditContractCompletePage} from './Members/View/Pages/EditContractInfo/MembersEditContractCompletePage'
import {MembersAuthLogoutPage} from './Members/View/Pages/Auth/MembersAuthLogoutPage'
import {MembersPageTemplate} from './Members/View/Molecules/BaseMembersPages/MembersPageTemplate'
import {Global} from '@emotion/react'
import {MemberGlobalStyles} from './Members/MemberGlobalStyles'
import {MembersVerifyIdentityPage} from './Members/View/Pages/ResetPassword/MembersVerifyIdentityPage'
import {MembersSendMailForVerificationIdentityPage} from './Members/View/Pages/ResetPassword/MembersSendMailForVerificationIdentityPage'
import {MemberResetPasswordRedirectPage} from './Members/View/Pages/ResetPassword/MemberResetPasswordRedirectPage'
import {MemberResetPasswordInputPage} from './Members/View/Pages/ResetPassword/MemberResetPasswordInputPage'
import {MemberResetPasswordCompletePage} from './Members/View/Pages/ResetPassword/MemberResetPasswordCompletePage'
import {MembersRedirectPage} from './Members/View/Pages/MembersRedirectPage'
import {MemberSignboardRepo} from './Members/Repo/MemberSignboardRepo'
import {MembersSignupResultPage} from './Members/View/Pages/Signup/MembersSignupResultPage'
import {MembersMobileCarrierTransitionPage} from './Members/View/Pages/MobileCarrierTransition/MembersMobileCarrierTransitionPage'
import {MembersJoinResultPage} from './Members/View/Pages/Join/MembersJoinResultPage'
import {MembersShippingAddressInputPage} from './Members/View/Pages/ShippingAddress/MembersShippingAddressInputPage'
import {MembersShippingAddressInputConfirmPage} from './Members/View/Pages/ShippingAddress/MembersShippingAddressInputConfirmPage'
import {MembersShippingAddressInputCompletePage} from './Members/View/Pages/ShippingAddress/MembersShippingAddressInputCompletePage'
import {MembersEditShippingAddressInputPage} from './Members/View/Pages/ShippingAddress/MembersEditShippingAddressInputPage'
import {MembersEditShippingAddressConfirmPage} from './Members/View/Pages/ShippingAddress/MembersEditShippingAddressConfirmPage'
import {MembersEditShippingAddressCompletePage} from './Members/View/Pages/ShippingAddress/MembersEditShippingAddressCompletePage'
import {MembersEditContractResultPage} from './Members/View/Pages/EditContractInfo/MembersEditContractResultPage'
import {useTranslation} from 'react-i18next'
import {gtm} from './index'
import {MembersAuthSsoLogoutPage} from "./Members/View/Pages/Auth/MembersAuthSsoLogoutPage";

export type AppMembersProps = {
  navigator: NavigatorForMemberPage
  memberRepo: MemberRepo
  memberSignboardRepo: MemberSignboardRepo
  memberAgreementRepo: MemberAgreementRepo
  searchPostCode: SearchPostCode
}

const AppMembers: React.VFC<AppMembersProps> = (props) => {
  const {navigator, memberRepo, memberSignboardRepo, memberAgreementRepo, searchPostCode} = props

  const {t, ready} = useTranslation('member')
  if (!ready) return null

  document.documentElement.className = 'members-pages'
  document.body.className = 'members-pages'

  useEffect(() => {
    gtm(process.env.REACT_APP_GTM_CONTAINER_ID)
    gtm(process.env.REACT_APP_MNG_GTM_CONTAINER_ID)
  }, [])

  return (
    <>
      <Global styles={MemberGlobalStyles}/>
      <ErrorBoundary fallbackRender={(fallbackProps): JSX.Element => {
        const switchErrorPages = (fallbackProps: FallbackProps): React.ReactElement => {
          switch (fallbackProps.error?.message) {
            case 'DisagreementError':
              return <MembersAuthLogoutPage to={window.location.pathname}/>
            case 'InvalidOperation':
              document.title = t('ご案内.タイトル')
              return <MembersInvalidOperationPage/>
            case 'Conflict':
              document.title = t('ご案内.タイトル')
              return (
                <MembersDuplicatedRegisterPage
                  navigator={navigator}
                  onLoginButtonClick={(): void => {
                    fallbackProps.resetErrorBoundary()
                  }}
                />
              )
            case 'NotFound':
              document.title = t('ご案内.タイトル')
              return <Members404Page/>
            case 'InvalidOneTimeUrl':
              document.title = t('ご案内.タイトル')
              return <MembersInvalidOneTimeUrlPage/>
            case 'SystemError':
              document.title = t('エラー.タイトル')
              return <Members500Page/>
            default:
              document.title = t('エラー.タイトル')
              return <Members500Page/>
          }
        }
        return <MembersPageTemplate>
          {switchErrorPages(fallbackProps)}
        </MembersPageTemplate>
      }}>
        <Switch>
          <RouteWithTitle
            exact path="/:signupKey/invitation"
            title={t('新規登録.タイトル')}
            render={(): React.ReactNode => (
              <MembersInvitationPage navigator={navigator} memberRepo={memberRepo}/>
            )}
          />
          <RouteWithTitle
            exact path="/:signupKey/invitation/complete"
            title={t('新規登録URL発行.タイトル')}
            render={(): React.ReactNode => (
              <MembersInvitationCompletePage/>
            )}
          />
          <RouteWithTitle
            exact path="/:signupKey/signup/input"
            title={t('新規登録情報入力.タイトル')}
            render={(): React.ReactNode => (
              <MembersSignupInputPage
                navigator={navigator}
                memberRepo={memberRepo}
                memberAgreementRepo={memberAgreementRepo}
                searchPostCode={searchPostCode}
              />
            )}
          />
          <RouteWithTitle
            exact path="/:signupKey/signup/confirm"
            title={t('新規登録情報確認.タイトル')}
            render={(): React.ReactNode => (
              <MembersSignupInputConfirmPage navigator={navigator} memberRepo={memberRepo}/>
            )}
          />
          <RouteWithTitle
            exact path="/:signupKey/signup/registered"
            title={t('新規登録完了.タイトル')}
            render={(): React.ReactNode => (
              <MembersRegisteredPage/>
            )}
          />
          <RouteWithTitle
            exact path="/signup/:invitationId"
            title=""
            render={(): React.ReactNode => (
              <MembersSignupRedirectPage repo={memberRepo} navigator={navigator}/>
            )}
          />
          <RouteWithTitle
            exact path="/signup/payment/mobileCarrierTransition"
            title=""
            render={(): React.ReactNode => (
              <MembersMobileCarrierTransitionPage/>
            )}
          />
          <RouteWithTitle
            exact path="/signup/result/:temporaryEnrollmentId"
            title=""
            render={(): React.ReactNode => (
              <MembersSignupResultPage
                repo={memberRepo}
                memberAgreementRepo={memberAgreementRepo}
                navigator={navigator}
              />
            )}
          />

          <RouteWithTitle
            exact path="/account"
            title={t('MYアカウント.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersAccountTopPage
                  navigator={navigator}
                  memberRepo={memberRepo}
                />
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information"
            title={t('登録情報.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersAccountInformationPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/mail/update_input"
            title={t('メールアドレス変更入力.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditMailInputPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/mail/send_complete"
            title={t('メールアドレス変更URL発行.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditMailSendCompletePage/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/mail/change/:mailUpdateId"
            title=""
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditMailRedirectPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/mail/update_complete"
            title={t('メールアドレス変更完了.タイトル')}
            render={(): React.ReactNode => (
              <MembersEditMailUpdatedPage navigator={navigator}/>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/password/update_input"
            title={t('パスワード変更.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditPasswordPage
                  navigator={navigator} memberRepo={memberRepo}
                />
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/password/update_complete"
            title={t('パスワード変更完了.タイトル')}
            render={(): React.ReactNode => (
              <MembersEditPasswordCompletePage navigator={navigator}/>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/address/update"
            title={t('連絡先情報変更入力.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditAddressInputPage
                  navigator={navigator} memberRepo={memberRepo} searchPostCode={searchPostCode}
                />
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/address/update_confirm"
            title={t('連絡先情報変更確認.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditAddressConfirmPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/address/update_complete"
            title={t('連絡先情報変更完了.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditAddressCompletePage navigator={navigator}/>
              </MembersAuth>
            )}
          />

          <RouteWithTitle
            exact path="/account/information/shipping_address/input"
            title={t('商品配送先情報入力.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersShippingAddressInputPage
                  navigator={navigator}
                  memberRepo={memberRepo}
                  searchPostCode={searchPostCode}
                />
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/shipping_address/input_confirm"
            title={t('商品配送先情報確認.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersShippingAddressInputConfirmPage
                  navigator={navigator}
                  memberRepo={memberRepo}
                />
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/shipping_address/input_complete"
            title={t('商品配送先情報登録完了.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersShippingAddressInputCompletePage
                  navigator={navigator}
                />
              </MembersAuth>
            )}
          />

          <RouteWithTitle
            exact path="/account/information/shipping_address/:shippingAddressId/update"
            title={t('商品配送先情報変更入力.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditShippingAddressInputPage
                  navigator={navigator}
                  memberRepo={memberRepo}
                  searchPostCode={searchPostCode}
                />
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/shipping_address/:shippingAddressId/update_confirm"
            title={t('商品配送先情報変更確認.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditShippingAddressConfirmPage
                  navigator={navigator}
                  memberRepo={memberRepo}
                />
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/account/information/shipping_address/:shippingAddressId/update_complete"
            title={t('商品配送先情報変更完了.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditShippingAddressCompletePage
                  navigator={navigator}
                />
              </MembersAuth>
            )}
          />

          <RouteWithTitle
            exact path="/:signupKey/join/input"
            title={t('新規会員情報入力.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersJoinInputPage
                  navigator={navigator}
                  memberRepo={memberRepo}
                  memberSignboardRepo={memberSignboardRepo}
                  memberAgreementRepo={memberAgreementRepo}
                  searchPostCode={searchPostCode}
                />
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/:signupKey/join/confirm"
            title={t('新規会員情報確認.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersJoinInputConfirmPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/:signupKey/join/complete"
            title={t('新規入会完了.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersJoinCompletePage/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/join/payment/mobileCarrierTransition"
            title=""
            render={(): React.ReactNode => (
              <MembersMobileCarrierTransitionPage/>
            )}
          />
          <RouteWithTitle
            exact path="/join/result/:temporaryEnrollmentId"
            title=""
            render={(): React.ReactNode => (
              <MembersJoinResultPage
                repo={memberRepo}
                memberAgreementRepo={memberAgreementRepo}
                navigator={navigator}
              />
            )}
          />

          <RouteWithTitle
            exact path="/:bucketKey/mail_magazine"
            title={t('メルマガ情報.タイトル')}
            render={(): React.ReactNode => (
              // MembersPageTemplate は MembersEditMailMagazineInfoPage戻り値に含まれている。
              // 認証情報はreturn文より前の処理、API呼び出し時に必要なためここでMemberAuthを呼び出す実装とする。
              <MembersAuth>
                <MembersEditMailMagazineInfoPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/:bucketKey/mail_magazine/update"
            title={t('メルマガ情報変更.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditMailMagazineInputPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/:bucketKey/mail_magazine/update_confirm"
            title={t('メルマガ情報変更確認.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditMailMagazineConfirmPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/:bucketKey/mail_magazine/update_complete"
            title={t('メルマガ情報変更完了.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditMailMagazineCompletePage/>
              </MembersAuth>
            )}
          />

          <RouteWithTitle
            exact path="/:bucketKey/contract"
            title={t('契約情報.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditContractInfoPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/:bucketKey/contract/update"
            title={t('お支払いに関する情報変更.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditContractInputPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/:bucketKey/contract/update_confirm"
            title={t('お支払いに関する情報変更確認.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditContractConfirmPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/:bucketKey/contract/update_complete"
            title={t('お支払いに関する情報変更完了.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersEditContractCompletePage navigator={navigator}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/contract/update/payment/mobileCarrierTransition"
            title=""
            render={(): React.ReactNode => (
              <MembersMobileCarrierTransitionPage/>
            )}
          />
          <RouteWithTitle
            exact path="/contract/update/result/:temporaryEnrollmentId"
            title=""
            render={(): React.ReactNode => (
              <MembersEditContractResultPage
                memberRepo={memberRepo}
                navigator={navigator}
              />
            )}
          />

          <RouteWithTitle
            exact path="/:bucketKey/leave"
            title={t('退会.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersLeaveBucketInputPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/:bucketKey/leave_confirm"
            title={t('退会確認.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersLeaveBucketConfirmPage navigator={navigator} memberRepo={memberRepo}/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/:bucketKey/leave_complete"
            title={t('退会完了.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuth>
                <MembersLeaveBucketCompletePage/>
              </MembersAuth>
            )}
          />
          <RouteWithTitle
            exact path="/password/reset/verify_identity"
            title={t('パスワード再設定用メールアドレス入力.タイトル')}
            render={(): React.ReactNode => (
              <MembersVerifyIdentityPage navigator={navigator} memberRepo={memberRepo}/>
            )}
          />
          <RouteWithTitle
            exact path="/password/reset/verified_identity"
            title={t('パスワード再設定用メール送信完了.タイトル')}
            render={(): React.ReactNode => (
              <MembersSendMailForVerificationIdentityPage/>
            )}
          />
          <RouteWithTitle
            exact path="/password/reset/input"
            title={t('パスワード再設定.タイトル')}
            render={(): React.ReactNode => (
              <MemberResetPasswordInputPage memberRepo={memberRepo} navigator={navigator}/>
            )}
          />
          <RouteWithTitle
            exact path="/password/reset/complete"
            title={t('パスワード再設定完了.タイトル')}
            render={(): React.ReactNode => (
              <MemberResetPasswordCompletePage navigator={navigator}/>
            )}
          />
          <RouteWithTitle
            exact path="/password/reset/:oneTimeToken"
            title=""
            render={(): React.ReactNode => (
              <MemberResetPasswordRedirectPage navigator={navigator} memberRepo={memberRepo}/>
            )}
          />

          <RouteWithTitle
            exact path="/redirect"
            title={t('リダイレクト.タイトル')}
            render={(): React.ReactNode => (
              <MembersRedirectPage navigator={navigator}/>
            )}
          />
          <RouteWithTitle
            exact path="/logout"
            title={t('ログアウト.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuthLogoutPage/>
            )}
          />
          <RouteWithTitle
            exact path="/sso_logout"
            title={t('ログアウト.タイトル')}
            render={(): React.ReactNode => (
              <MembersAuthSsoLogoutPage/>
            )}
          />

          <RouteWithTitle
            exact path="/invalidUrl"
            title={t('ご案内.タイトル')}
            render={(): React.ReactNode => (<MembersPageTemplate>
              <Members404Page/>
            </MembersPageTemplate>)}
          />
          <RouteWithTitle
            exact path="/invalidOneTimeUrl"
            title={t('ご案内.タイトル')}
            render={(): React.ReactNode => (<MembersPageTemplate>
              <MembersInvalidOneTimeUrlPage/>
            </MembersPageTemplate>)}
          />
          <RouteWithTitle
            exact path="/serverError"
            title={t('エラー.タイトル')}
            render={(): React.ReactNode => (<MembersPageTemplate>
              <Members500Page/>
            </MembersPageTemplate>)}
          />
          <RouteWithTitle
            exact path="/invalidOperation"
            title={t('ご案内.タイトル')}
            render={(): React.ReactNode => (<MembersPageTemplate>
              <MembersInvalidOperationPage/>
            </MembersPageTemplate>)}
          />
          <RouteWithTitle
            exact path="/duplicatedRegister"
            title={t('ご案内.タイトル')}
            render={(): React.ReactNode => (<MembersPageTemplate>
              <MembersDuplicatedRegisterPage navigator={navigator}/>
            </MembersPageTemplate>)}
          />

          <RouteWithTitle
            title={t('ご案内.タイトル')}
            render={(): React.ReactNode => (<MembersPageTemplate>
              <Members404Page/>
            </MembersPageTemplate>)}
          />
        </Switch>
      </ErrorBoundary>
    </>
  )
}

export default AppMembers
